<template>
	<div>
		<Head :title="reminder.title" />

		<Breadcrumbs
			href="/reminders"
			:parentLabel="__('Reminders')"
			:childLabel="`Statistik för '${reminder.title}'`"
		/>

		<TrashedMessage v-if="reminder.deleted_at" class="mb-6">
			{{ __('This reminder has been deleted.') }}
		</TrashedMessage>

        <div class="mb-16 flex flex-wrap">
            <table border="0" cellpadding="4" cellspacing="0" class="leading-tight">
                <tr valign="top">
                    <td class="text-[18px] py-2 font-bold w-[192px]">Tidpunkt för utskicket:&nbsp;&nbsp;&nbsp;</td>
                    <td class="text-[18px] py-2">{{ reminder.send_date }}</td>
                </tr>
                <tr valign="top">
                    <td class="text-[18px] py-2 font-bold w-[192px]">Antal mottagare:</td>
                    <td class="text-[18px] py-2">{{ reminder.number_of_recipients }} st</td>
                </tr>
                <tr valign="top">
                    <td class="text-[18px] py-2 font-bold w-[192px]">Urvalskriterier:</td>
                    <td class="text-[18px] py-2" v-html="getFilterCriteria(reminder)"></td>
                </tr>
            </table>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 xl:gap-16 mb-16 max-w-[915px]">
            <div>
                <h4 class="font-bold text-center">Open rate {{ openRatePercentage }}%</h4>
                <Pie :chart-data="openRateData" :chart-options="chartOptions"  />
            </div>
            <div>
                <h4 class="font-bold text-center">CTR {{ ctrPercentage }}%</h4>
                <Pie :chart-data="ctrData" :chart-options="chartOptions" />
            </div>
            <div>
                <h4 class="font-bold text-center">CTOR {{ctorPercentage}}%</h4>
                <Pie :chart-data="ctorData" :chart-options="chartOptions" />
            </div>
        </div>


        <div class="mb-16 flex flex-wrap flex-col">
            <div v-if="reminder.persons_that_read_the_mail">
                <h2 class="text-3xl font-bold mb-4">Personer som har öppnat brevet ({{ reminder.persons_that_read_the_mail.length }} st)</h2>
                <OpenedMailTable :persons="reminder.persons_that_read_the_mail" />

<!--                <table border="1" cellpadding="0" cellspacing="0" class="w-full max-w-[915px] table-fixed">-->
<!--                    <thead>-->
<!--                        <tr valign="top">-->
<!--                            <th class="text-[20px] p-2 text-left">Namn</th>-->
<!--                            <th class="text-[20px] p-2 text-left">Befattning</th>-->
<!--                            <th class="text-[20px] p-2 text-left">Specialistområde</th>-->
<!--                            <th class="text-[20px] p-2 text-left">Region</th>-->
<!--                        </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                        <tr valign="top" v-for="person in reminder.persons_that_read_the_mail">-->
<!--                            <td class="text-[16px] p-2">{{person.name}}</td>-->
<!--                            <td class="text-[16px] p-2">{{person?.role?.name || '-' }}</td>-->
<!--                            <td class="text-[16px] p-2">{{person?.speciality || '-' }}</td>-->
<!--                            <td class="text-[16px] p-2">{{person?.region?.name || '-'}}</td>-->
<!--                        </tr>-->
<!--                    </tbody>-->
<!--                </table>-->
            </div>
            <div v-else>
                <h2 class="text-3xl font-bold">Inga personer har öppnat brevet ännu.</h2>
            </div>
        </div>
        <div class="mb-16 flex flex-wrap flex-col">
            <div v-if="reminder.links_with_clicks.length != 0">
                <h2 class="text-3xl font-bold">Klickade länkar</h2>
                <div v-if="Object.keys(reminder.links_with_clicks).length">
                    <div v-for="(persons, link) in reminder.links_with_clicks" :key="link">
                        <LinksWithClicksTable :link="link" :persons="persons" />
                    </div>
                </div>
<!--                <table border="1" cellpadding="0" cellspacing="0" class="mb-16 w-full max-w-[915px] table-fixed" v-for="(persons, link) in reminder.links_with_clicks">-->
<!--                    <thead>-->
<!--                        <tr valign="top">-->
<!--                            <td colspan="4" class="text-[24px] py-4 font-bold">Länk: {{link}}</td>-->
<!--                        </tr>-->
<!--                        <tr valign="top">-->
<!--                            <th class="text-[20px] p-2 text-left">Namn</th>-->
<!--                            <th class="text-[20px] p-2 text-left">Befattning</th>-->
<!--                            <th class="text-[20px] p-2 text-left">Specialistområde</th>-->
<!--                            <th class="text-[20px] p-2 text-left">Region</th>-->
<!--                        </tr>-->
<!--                    </thead>-->
<!--                    <tbody>-->
<!--                        <tr v-for="person in persons">-->
<!--                            <td class="text-[16px] p-2">{{person.name}}</td>-->
<!--                            <td class="text-[16px] p-2">{{person?.role?.name || '-' }}</td>-->
<!--                            <td class="text-[16px] p-2">{{person?.speciality || '-' }}</td>-->
<!--                            <td class="text-[16px] p-2">{{person?.region?.name || '-'}}</td>-->
<!--                        </tr>-->
<!--                    </tbody>-->
<!--                </table>-->
            </div>
            <div v-else>
                <h2 class="text-3xl font-bold">Inga klick har registrerats ännu.</h2>
            </div>
        </div>
    </div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import TrashedMessage from '@/Shared/TrashedMessage'
	import Breadcrumbs 	  from '@/Shared/Breadcrumbs'
    import { Pie } 	    from 'vue-chartjs'
    import { Chart, registerables } from 'chart.js'
    import OpenedMailTable from './Partials/OpenedMailTable'
    import LinksWithClicksTable from './Partials/LinksWithClicksTable'

    Chart.register(...registerables)

	export default {
		components: {
			Head,
			Breadcrumbs,
			TrashedMessage,
            Pie,
            OpenedMailTable,
            LinksWithClicksTable,
		},
		layout: Layout,
		props: {
			reminder: Object,
		},
		data() {
			return {
                chartOptions: {
                    responsive: true,
                    // maintainAspectRatio: false,
                },
            }
		},
        computed: {
            totalUniqueClicks() {
                const uniqueUsers = new Set();
                for (const users of Object.values(this.reminder.links_with_clicks)) {
                    users.forEach(user => uniqueUsers.add(user.id));
                }
                return uniqueUsers.size;
            },
            openRateData() {
                return {
                    labels: ['Öppnat', 'Ej öppnat'],
                    datasets: [
                        {
                            data: [
                                this.reminder.persons_that_read_the_mail.length,
                                this.reminder.number_of_recipients - this.reminder.persons_that_read_the_mail.length,
                            ],
                            backgroundColor: ['#0079af', '#123e6b'],
                        },
                    ],
                }
            },
            ctrData() {
                return {
                    labels: ['Klickat', 'Ej klickat'],
                    datasets: [
                        {
                            data: [
                                this.totalUniqueClicks,
                                this.reminder.number_of_recipients - this.totalUniqueClicks,
                            ],
                            backgroundColor: ['#0079af', '#123e6b'],
                        },
                    ],
                }
            },
            ctorData()
            {
                return {
                    labels: ['Klickat', 'Ej klickat'],
                    datasets: [
                        {
                            data: [
                                this.totalUniqueClicks,
                                this.reminder.persons_that_read_the_mail.length - this.totalUniqueClicks,
                            ],
                            backgroundColor: ['#0079af', '#123e6b'],
                        },
                    ],
                }
            },
            openRatePercentage() {
                return Math.round((this.reminder.persons_that_read_the_mail.length / this.reminder.number_of_recipients) * 100);
            },
            ctrPercentage() {
                return Math.round((this.totalUniqueClicks / this.reminder.number_of_recipients) * 100);
            },
            ctorPercentage() {
                return Math.round((this.totalUniqueClicks / this.reminder.persons_that_read_the_mail.length) * 100);
            },
        },
        methods: {
            getFilterCriteria(reminder) {
                const sendDate = new Date(reminder.send_date);
                sendDate.setMonth(sendDate.getMonth() - reminder.last_order_months_ago);
                const lastOrderDateFormatted = sendDate.toISOString().split('T')[0];

                let filterCriteria = `<p class="mb-[8px]">Kunder som inte har gjort någon beställning efter ${lastOrderDateFormatted}</p>`;

                const productsNames = reminder.products.map(product => product.name.charAt(0).toUpperCase() + product.name.slice(1));
                filterCriteria += productsNames.length ? `<p class="mb-[8px]">${productsNames.join(', ')}</p>` : `<p>Alla produkter</p>`;

                const regionsNames = reminder.regions.map(region => region.name.charAt(0).toUpperCase() + region.name.slice(1));
                filterCriteria += regionsNames.length ? `<p class="mb-[8px]">${regionsNames.join(', ')}</p>` : `<p>Alla regioner</p>`;

                const rolesNames = reminder.roles.map(role => role.name.charAt(0).toUpperCase() + role.name.slice(1));
                filterCriteria += rolesNames.length ? `<p>${rolesNames.join(', ')}</p>` : `<p>Alla roller</p>`;

                return filterCriteria;
            }
        }
	}
</script>
